import Rellax from 'rellax';
import imagesLoaded from 'imagesloaded';

export const initParallax = function() {
  const element = arguments[0];
  const wrapper_el = arguments[1];
  const md = arguments[2];

  $( element ).each( function(i,e){
      let wrapper_list = $(this).closest(wrapper_el);

    let wrapper = wrapper_list[0];

      let speed = -2;
      if( md.phone() ){
        speed = -1;
      }

      imagesLoaded(e, () => {
        new Rellax(e, {
          center: true,
          speed: speed,
          wrapper,
          relativeToWrapper: !!wrapper
        });
      });

  });


};